class MegaMenu extends SimpleMegaMenu {
  constructor() {
    super();
    this.anchor = this.dataset.anchor;
    this.content = this.querySelector('.mega-menu__content');
    this.targetDesktop = document.querySelector(`li[data-anchor="${this.anchor}"]`);
    this.targetMobile = document.querySelector(
      `details[data-anchor="${this.anchor}"] .menu-drawer__inner-submenu .menu-drawer__menu`
    );
    this.isAlreadyConnected = false; // Prevent infinit loop
  }

  connectedCallback() {
    // Call the connectedCallback of SimpleMegaMenu
    super.connectedCallback();

    if (this.isAlreadyConnected) return;
    this.isAlreadyConnected = true;

    const contentClone = this.content.cloneNode(true);
    this.targetDesktop && this.targetDesktop.firstChild.replaceWith(this);
    this.targetMobile && this.targetMobile.replaceWith(contentClone);
    this.classList.add('mega-menu--is-ready');
  }
}

customElements.define('mega-menu', MegaMenu);
